// ============================================================
// PHADE BARBERS — SITE CONTENT & LINKS
// Everything editable lives in this one file.
// TODO: paste each barber's real booking URL and Instagram URL
// below when the client supplies them. Empty strings render
// safe placeholder links that go nowhere.
// ============================================================

export const BUSINESS = {
  name: "Phade Barbers",
  city: "Calhoun, Georgia",
  address: "407 Oothcalooga St",
  addressFull: "407 Oothcalooga St, Calhoun, GA 30701",
  phoneDisplay: "(678) 918-0868",
  phoneTel: "+16789180868",
  // TODO: replace with the shop's real Instagram profile URL
  instagramUrl: "https://instagram.com/",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=407+Oothcalooga+St,+Calhoun,+GA+30701",
  mapsEmbed:
    "https://maps.google.com/maps?q=407%20Oothcalooga%20St%2C%20Calhoun%2C%20GA%2030701&z=15&output=embed",
  // Opens the shop's Google listing where clients can leave a review.
  // TODO: for a direct write-a-review link, replace with
  // https://search.google.com/local/writereview?placeid=YOUR_PLACE_ID
  googleReviewUrl:
    "https://www.google.com/maps/search/?api=1&query=Phade+Barbers+Calhoun+GA",
  hours: [
    { day: "Monday", time: "9 AM – 7 PM" },
    { day: "Tuesday", time: "9 AM – 7 PM" },
    { day: "Wednesday", time: "9 AM – 7 PM" },
    { day: "Thursday", time: "9 AM – 7 PM" },
    { day: "Friday", time: "9 AM – 7 PM" },
    { day: "Saturday", time: "9 AM – 5 PM" },
    { day: "Sunday", time: "Closed" },
  ],
};

export const NAV_LINKS = [
  { id: "home", label: "HOME" },
  { id: "barbers", label: "BARBERS" },
  { id: "services", label: "SERVICES" },
  { id: "gallery", label: "GALLERY" },
  { id: "reviews", label: "REVIEWS" },
  { id: "contact", label: "CONTACT" },
];

export const BARBERS = [
  {
    id: "nomisfades",
    name: "NOMISFADES",
    years: 7,
    cta: "BOOK WITH SIMON",
    bookingUrl: "https://book.squareup.com/appointments/sfjg7uv7e81har/location/277114TMJ2GRK/services",
    instagramUrl: "https://www.instagram.com/nomisfades/",
    initials: "NF",
    photo: "/assets/barbers/kevin-bmb.jpg",
  },
  {
    id: "kevin-bmb",
    name: "KEVIN / BMB",
    years: 4,
    cta: "BOOK WITH KEVIN",
    bookingUrl: "https://michaelie2x.setmore.com/",
    instagramUrl: "https://www.instagram.com/bmblendz14/",
    initials: "KB",
    photo: "/assets/barbers/jc-blenddz.jpg",
  },
  {
    id: "jc-blenddz",
    name: "JC BLENDDZ",
    years: 3,
    cta: "BOOK WITH JC",
    bookingUrl: "http://jcblenddz.booksy.com/a/",
    instagramUrl: "https://www.instagram.com/jcblenddz/",
    initials: "JC",
    photo: "/assets/barbers/boomin-blendz.jpg",
  },
  {
    id: "boomin-blendz",
    name: "BOOMIN BLENDZ",
    years: 4,
    cta: "TEXT TO BOOK",
    sms: true, // opens the phone's messaging app
    smsNumber: "+17622010032",
    smsBody: "Hey Boomin, I found you through the Phade Barbers website and I'd like to book a haircut.",
    bookingUrl: "",
    instagramUrl: "https://www.instagram.com/boomin_blendz/",
    initials: "BB",
    photo: "/assets/barbers/yevi-fades.jpg",
  },
  {
    id: "yevi-fades",
    name: "YEVI FADES",
    years: 9,
    cta: "BOOK WITH YEVI",
    bookingUrl: "https://booksy.com/en-us/dl/show-business/1029672",
    instagramUrl: "https://www.instagram.com/yevifades/",
    initials: "YF",
    photo: "/assets/barbers/nomisfades.jpg",
  },
];

export const SERVICES = [
  { num: "01", title: "SIGNATURE HAIRCUT", desc: "Custom cut and style tailored to you." },
  { num: "02", title: "SKIN FADE", desc: "Seamless blended fade down to the skin." },
  { num: "03", title: "BEARD TRIM & SHAPE", desc: "Clean, sculpted beard line and trim." },
  { num: "04", title: "CUT & BEARD COMBO", desc: "Haircut paired with beard work." },
  { num: "05", title: "KIDS CUT", desc: "Fresh, clean cuts for the next generation." },
  { num: "06", title: "LINEUP / EDGE UP", desc: "Sharp, precise edge-up to refresh any look." },
  { num: "07", title: "HAIR DESIGN", desc: "Custom artwork and designs cut into the fade." },
  { num: "08", title: "HOT TOWEL SHAVE", desc: "Classic straight-razor shave with a hot towel." },
];

export const GALLERY = [
  {
    src: "/assets/gallery-1.jpg",
    alt: "Freestyle hair design cut into a dark textured fade at Phade Barbers",
  },
  {
    src: "/assets/gallery-2.jpg",
    alt: "Clean skin fade with a full sculpted beard at Phade Barbers in Calhoun",
  },
  {
    src: "/assets/gallery-3.jpg",
    alt: "Kids cut with a star hair design and sharp fade at Phade Barbers",
  },
  {
    src: "/assets/gallery-4.jpg",
    alt: "Fresh burst fade with a clean taper at Phade Barbers in Calhoun",
  },
  {
    src: "/assets/gallery-5.jpg",
    alt: "Tight fade with natural curls on top and a shaped beard at Phade Barbers",
  },
  {
    src: "/assets/gallery-6.jpg",
    alt: "Kids cut with textured flow, finished in the red Phade cape",
  },
];

// Real Google reviews transcribed from the approved reference design
export const REVIEWS = [
  {
    name: "Joey Marycz",
    initial: "J",
    text: "Absolutely fantastic experience at Phade From the moment I walked in, the atmosphere was welcoming and professional. Yevi took the time to understand exactly what I wanted and executed it flawlessly. The attention to detail was impressive, leaving me with a precise cut. Highly recommend for anyone in search of a top-notch barber.",
  },
  {
    name: "Trey Gentry",
    initial: "T",
    text: "Brent is the best barber I've had in GA, hands down. In two years I've never used anyone else and never had a haircut I didn't like. He can give you anything you want. Highly recommend!",
  },
  {
    name: "Jonathan Rivas",
    initial: "J",
    text: "One of the best barber shops I've been to around Calhoun area , great customer service from all barbers. I recommend Kevin \u201CBoomin blendz\u201D he does outstanding work and always leaves me feeling good walking out the barber shop 10/10 experience!",
  },
  {
    name: "Demetrius Mungo",
    initial: "D",
    text: "My boy Simon always hooks me up. Best barber i been to in ga. Definately worth a try to anyone looking for a fresh cut and a good permanent barber.",
  },
];

export const MARQUEE_ITEMS = [
  "SKIN FADES",
  "BEARD WORK",
  "HAIR DESIGNS",
  "HOT TOWEL SHAVES",
  "KIDS CUTS",
  "LINEUPS",
  "CALHOUN, GEORGIA",
];
